import { ENDPOINT, RELATIONSHIP } from "../utils/constants";
import { getServerUrl, oAuthRequest, request } from "../utils/request";


export const getCourseFirstLesson = (courseId) =>{

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/lessonOne/${courseId}`,
        method:'get'
    });

}

export const getLearningPathBreakdown = (learningPathId) =>{

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/learning-path/${learningPathId}/breakdown`,
        method:'get'
    });

}

export const getLearningPathStepBreakdown = (learningPathStepId) =>{

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/learning-path-step/${learningPathStepId}/breakdown`,
        method:'get'
    });

}

export const getNavigationMenu = (assetId,assetType) => {
    const baseFields = [
        "id",
        "name",
        "position",
        "title",
        "title_i18n"
    ]

    const menuFields = [
        ...baseFields,
        ...[...baseFields, "friendlyUrlPath"].map((field) => `${RELATIONSHIP.MODULES_TO_LESSONS}.${field}`),
		...[...baseFields, "friendlyUrlPath"].map((field) => `${RELATIONSHIP.MODULES_TO_QUIZZES}.${field}`),
    ].map((field) => `${RELATIONSHIP.COURSES_TO_MODULES}.${field}`);

    return request({
        url: `${ENDPOINT.COURSES}?filter=${RELATIONSHIP.COURSES_TO_MODULES}/${assetType}/id eq '${assetId}'&nestedFields=${RELATIONSHIP.COURSES_TO_MODULES},${RELATIONSHIP.MODULES_TO_LESSONS},${RELATIONSHIP.MODULES_TO_QUIZZES}&nestedFieldsDepth=2&fields=${menuFields.join(",")}`,
        method:'get' 
    })
}

export const getCoursesPaged = (page,pageSize) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/courses?page=${page}&pageSize=${pageSize}`,
        method:'get'
    });

}

export const getLearningPathsPaged = (page,pageSize) => {

    let serviceBaseAddress = getServerUrl();

    return oAuthRequest({
        url:`${serviceBaseAddress}${ENDPOINT.MENU}/learning-paths?page=${page}&pageSize=${pageSize}`,
        method:'get'
    });

}
